module.exports = __webpack_public_path__ + "media/images/emblems/S-chanf_wappen-a095bf8ccb626a2b309c57979b189340.svg";